export const LICENSE_KEY_LENGTH = 64;
